import PrimaryButtom from 'components/common/buttons/primary-btn';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center w-full h-full">
      <label className="text-4xl font-bold">🚧 {t('WORK_IN_PROGESS')}</label>
      <label className="text-xl font-medium">{t('CHECK_BACK_LATER')}</label>
      <div className="flex items-center justify-center mt-10">
        <PrimaryButtom label={t('BACK_HOME')} onClick={() => navigate('/')} />
      </div>
    </div>
  );
};

export default NotFound;
